import * as React from "react";
import EndpointContext from "../context/EndpointContext";

export const PopoutIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    />
  </svg>
);

export const CollapseIcon = (props: { color: string }) => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
  >
    <line
      x1="6"
      x2="18"
      y1="12"
      y2="12"
      style={{ stroke: props.color, strokeWidth: 2 }}
    />
  </svg>
);

export const CloseIcon = (props: { color: string }) => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill={props.color}
    />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export const PrintIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="14"
    height="14"
    viewBox="0 0 16 16"
  >
    <path
      d="M4,12.5v3h8v-3v-2H4V12.5z M5,11.5h6v1H5V11.5z M5,13.5h6v1H5V13.5z"
      fill="#000000"
    />
    <polygon points="12,3.5 12,0.5 4,0.5 4,3.5 4,5.5 12,5.5" fill="#000000" />
    <path
      d="M14,3.5h-1v2v1H3v-1v-2H2c-1,0-2,1-2,2v5c0,1,1,2,2,2h1v-2v-1h10v1v2h1c1,0,2-1,2-2v-5 C16,4.5,15,3.5,14,3.5z"
      fill="#000000"
    />
  </svg>
);

export const EmailIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="14px"
    height="14px"
    viewBox="0 0 511.626 511.626"
  >
    <path
      d="M49.106,178.729c6.472,4.567,25.981,18.131,58.528,40.685c32.548,22.554,57.482,39.92,74.803,52.099 c1.903,1.335,5.946,4.237,12.131,8.71c6.186,4.476,11.326,8.093,15.416,10.852c4.093,2.758,9.041,5.852,14.849,9.277 c5.806,3.422,11.279,5.996,16.418,7.7c5.14,1.718,9.898,2.569,14.275,2.569h0.287h0.288c4.377,0,9.137-0.852,14.277-2.569 c5.137-1.704,10.615-4.281,16.416-7.7c5.804-3.429,10.752-6.52,14.845-9.277c4.093-2.759,9.229-6.376,15.417-10.852 c6.184-4.477,10.232-7.375,12.135-8.71c17.508-12.179,62.051-43.11,133.615-92.79c13.894-9.703,25.502-21.411,34.827-35.116 c9.332-13.699,13.993-28.07,13.993-43.105c0-12.564-4.523-23.319-13.565-32.264c-9.041-8.947-19.749-13.418-32.117-13.418H45.679 c-14.655,0-25.933,4.948-33.832,14.844C3.949,79.562,0,91.934,0,106.779c0,11.991,5.236,24.985,15.703,38.974 C26.169,159.743,37.307,170.736,49.106,178.729z"
      fill="#000000"
    />
    <path
      d="M483.072,209.275c-62.424,42.251-109.824,75.087-142.177,98.501c-10.849,7.991-19.65,14.229-26.409,18.699 c-6.759,4.473-15.748,9.041-26.98,13.702c-11.228,4.668-21.692,6.995-31.401,6.995h-0.291h-0.287 c-9.707,0-20.177-2.327-31.405-6.995c-11.228-4.661-20.223-9.229-26.98-13.702c-6.755-4.47-15.559-10.708-26.407-18.699 c-25.697-18.842-72.995-51.68-141.896-98.501C17.987,202.047,8.375,193.762,0,184.437v226.685c0,12.57,4.471,23.319,13.418,32.265 c8.945,8.949,19.701,13.422,32.264,13.422h420.266c12.56,0,23.315-4.473,32.261-13.422c8.949-8.949,13.418-19.694,13.418-32.265 V184.437C503.441,193.569,493.927,201.854,483.072,209.275z"
      fill="#000000"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="16px"
    height="16px"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M448 56.7v398.5c0 13.7-11.1 24.7-24.7 24.7H309.1V306.5h58.2l8.7-67.6h-67v-43.2c0-19.6 5.4-32.9 33.5-32.9h35.8v-60.5c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9h-58.4v67.6h58.4V480H24.7C11.1 480 0 468.9 0 455.3V56.7C0 43.1 11.1 32 24.7 32h398.5c13.7 0 24.8 11.1 24.8 24.7z"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="16px"
    height="16px"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="16px"
    height="16px"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 488 512"
  >
    <path
      fill="currentColor"
      d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
    />
  </svg>
);

export const LinkedInIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="16px"
    height="16px"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
    />
  </svg>
);

export const HeaderSmileyIcon = () => (
  <div className="velaro-header-smiley">
    <svg
      focusable="false"
      aria-hidden="true"
      version="1.1"
      x="0px"
      y="0px"
      width="104.878px"
      height="66.881px"
      viewBox="0 0 104.878 66.881"
      enableBackground="new 0 0 104.878 66.881"
    >
      <rect
        x="-321.683"
        y="-354.879"
        display="none"
        fill="#6D1616"
        stroke="#000000"
        strokeMiterlimit="10"
        width="667"
        height="819"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M103.378,37.686c0,4.782,0,26.979,0,26.979l-19.272-7.709H67.771c-10.645,0-19.271-8.628-19.271-19.271V21.349 c0-10.644,8.627-19.271,19.271-19.271h16.335c10.645,0,19.272,8.627,19.272,19.271V37.686z"
      />
      <circle
        fillRule="evenodd"
        className="eyes"
        clipRule="evenodd"
        fill="#FFFFFF"
        cx="86.129"
        cy="21.525"
        r="4.167"
        style={{ stroke: "rgb(117, 185, 230)" }}
      />
      <circle
        fillRule="evenodd"
        className="eyes"
        clipRule="evenodd"
        fill="#FFFFFF"
        cx="65.963"
        cy="21.525"
        r="4.167"
        style={{ stroke: "rgb(117, 185, 230)" }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M64.251,33.1c0,6.454,5.232,11.687,11.688,11.687c6.454,0,11.686-5.232,11.686-11.687"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M1.5,28.034c0,3.564,0,20.105,0,20.105l14.362-5.744h12.173c7.933,0,14.361-6.43,14.361-14.361V15.86 c0-7.932-6.429-14.36-14.361-14.36H15.862C7.93,1.5,1.5,7.929,1.5,15.86V28.034z"
      />
      <circle
        fillRule="evenodd"
        className="eyes"
        clipRule="evenodd"
        fill="#FFFFFF"
        cx="14.354"
        cy="15.992"
        r="3.105"
        style={{ stroke: "rgb(117, 185, 230)" }}
      />
      <circle
        fillRule="evenodd"
        className="eyes"
        clipRule="evenodd"
        fill="#FFFFFF"
        cx="29.382"
        cy="15.992"
        r="3.105"
        style={{ stroke: "rgb(117, 185, 230)" }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M30.658,24.617c0,4.81-3.899,8.709-8.71,8.709c-4.81,0-8.708-3.899-8.708-8.709"
      />
    </svg>
  </div>
);

export const AttachmentIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 351.136 351.136"
    width="12px"
    height="12px"
  >
    <g>
      <path
        d="M324.572,42.699c-35.419-35.419-92.855-35.419-128.273,0L19.931,219.066c-26.575,26.575-26.575,69.635,0,96.211 c21.904,21.904,54.942,25.441,80.769,11.224c2.698-0.136,5.351-1.156,7.415-3.197l176.367-176.367 c17.709-17.709,17.709-46.416,0-64.125s-46.416-17.709-64.125,0L76.052,227.116c-4.422,4.422-4.422,11.61,0,16.031 c4.422,4.422,11.61,4.422,16.031,0L236.388,98.843c8.866-8.866,23.219-8.866,32.063,0c8.866,8.866,8.866,23.219,0,32.063 L100.088,299.268c-17.709,17.709-46.416,17.709-64.125,0s-17.709-46.416,0-64.125L212.33,58.73 c26.575-26.575,69.635-26.575,96.211,0c26.575,26.575,26.575,69.635,0,96.211L148.205,315.277c-4.422,4.422-4.422,11.61,0,16.031 c4.422,4.422,11.61,4.422,16.031,0l160.336-160.336C359.991,135.554,359.991,78.118,324.572,42.699z"
        fill="#73808f"
      />
    </g>
  </svg>
);

export const SendIcon = (props: { color: string }) => (
  <svg
    focusable="false"
    aria-hidden="true"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 334.5 334.5"
    width="12px"
    height="12px"
  >
    <path
      d="M332.797,13.699c-1.489-1.306-3.608-1.609-5.404-0.776L2.893,163.695c-1.747,0.812-2.872,2.555-2.893,4.481  s1.067,3.693,2.797,4.542l91.833,45.068c1.684,0.827,3.692,0.64,5.196-0.484l89.287-66.734l-70.094,72.1  c-1,1.029-1.51,2.438-1.4,3.868l6.979,90.889c0.155,2.014,1.505,3.736,3.424,4.367c0.513,0.168,1.04,0.25,1.561,0.25  c1.429,0,2.819-0.613,3.786-1.733l48.742-56.482l60.255,28.79c1.308,0.625,2.822,0.651,4.151,0.073  c1.329-0.579,2.341-1.705,2.775-3.087L334.27,18.956C334.864,17.066,334.285,15.005,332.797,13.699z"
      fill={props.color}
    />
  </svg>
);

export const MenuIcon = (props: { color: string }) => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill={props.color}
      d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </svg>
);

const CdnIcon = (path: string) => (
  <EndpointContext.Consumer>
    {(endpoints) => (
      <img src={`${endpoints.images}${path}`} alt="" role="presentation" />
    )}
  </EndpointContext.Consumer>
);

export const DataFieldSendIcon = (props: { color?: string }) => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="40"
    viewBox="0 0 24 24"
  >
    <path
      d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
      fill={props.color || "#fff"}
    />
    <path fill="none" d="M0 0h24v24H0V0z" />
  </svg>
);

export const ChevronLeft = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="#fff" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export const ChevronRight = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#fff" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export const ArrowLeft = (props: { color: string }) => (
  <svg
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M22,12a1,1,0,0,1-1,1H5.414l5.293,5.293a1,1,0,1,1-1.414,1.414l-7-7a1,1,0,0,1,0-1.414l7-7a1,1,0,1,1,1.414,1.414L5.414,11H21A1,1,0,0,1,22,12Z"
      fill={props.color}
    />
  </svg>
);

export const PrivacyPolicyIcon = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="16px"
    height="16px"
  >
    <path
      fill="currentColor"
      d="M24.707,8.793l-6.5-6.5C18.019,2.105,17.765,2,17.5,2H7C5.895,2,5,2.895,5,4v22c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2 V9.5C25,9.235,24.895,8.981,24.707,8.793z M18,21h-8c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1 C19,20.552,18.552,21,18,21z M20,17H10c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1C21,16.552,20.552,17,20,17 z M18,10c-0.552,0-1-0.448-1-1V3.904L23.096,10H18z" />
  </svg>
);

export const TickIcon = () => CdnIcon("/inline/tick-icon.png");
export const Twitter = () => CdnIcon("/inline/twitter-icon.png");
export const Facebook = () => CdnIcon("/inline/facebook-icon.png");
export const Google = () => CdnIcon("/inline/google-icon.png");
export const LinkedIn = () => CdnIcon("/inline/linkedin-icon.png");
export const FacebookButton = () => CdnIcon("/facebook.png");
export const TwitterButton = () => CdnIcon("/twitter.png");
export const GoogleButton = () => CdnIcon("/google.png");
export const LinkedInButton = () => CdnIcon("/linkedin.png");
